import axios from '@/utils/axiosHelper'

// 初始化
export const onInitAPI = (params) => {
    return axios({ url: '/sword/year/init', method: 'GET', params }, { interceptResultCode: false })
}

// 领取任务奖励
export const onGetRewardAPI = (params) => {
    return axios({ url: '/sword/year/get', method: 'POST', params }, { interceptResultCode: false })
}

// 注销
export const onLogoutAPI = (params) => {
    return axios({ url: '/login/free/loginout', method: 'POST', params }, { interceptResultCode: false })
}

// 购买道具
export const onBuyItemAPI = (params) => {
    return axios({ url: '/sword/year/buy', method: 'POST', params }, { interceptResultCode: false })
}

// 售卖古玉
export const onSellItemAPI = (params) => {
    return axios({ url: '/sword/year/store', method: 'POST', params }, { interceptResultCode: false })
}


// 当铺链接初始化
export const onHelpInitAPI = (params) => {
    return axios({ url: '/sword/year/help', method: 'GET', params }, { interceptResultCode: false })
}

// 在别人当铺售卖古玉
export const otherSellItemAPI = (params) => {
    return axios({ url: '/sword/year/sale', method: 'POST', params }, { interceptResultCode: false })
}




// WEBPACK FOOTER //
// ./src/pages/hjwq/aniEvent/api.js